import { useId } from "react";

const Logo = ({ light = false }) => {
  const uid = useId().replace(/:/g, "");
  const stripes = `smc-stripes-${uid}`;
  return (
    <span data-testid="brand-logo" className="inline-flex flex-col items-stretch select-none">
      <span className="flex items-end justify-between gap-2">
        <span
          className={`font-logo font-bold tracking-[0.05em] leading-none text-lg ${
            light ? "text-white" : "text-[#C62828]"
          }`}
        >
          SAI MOHAN
        </span>
        <svg width="34" height="26" viewBox="0 0 60 48" aria-hidden="true" className="shrink-0 -mb-0.5">
          <defs>
            <pattern id={stripes} width="4" height="3.2" patternUnits="userSpaceOnUse">
              <rect width="4" height="1.3" fill="#ffffff" opacity="0.9" />
            </pattern>
          </defs>
          <rect x="2" y="16" width="15" height="32" fill="#4A82A0" />
          <rect x="2" y="16" width="15" height="32" fill={`url(#${stripes})`} />
          <rect x="21" y="2" width="19" height="46" fill="#2F6385" />
          <rect x="21" y="2" width="19" height="46" fill={`url(#${stripes})`} />
          <rect x="44" y="20" width="13" height="28" fill="#5A93AF" />
          <rect x="44" y="20" width="13" height="28" fill={`url(#${stripes})`} />
        </svg>
      </span>
      <span className="mt-1 bg-[#C62828] text-white font-logo font-bold text-[10px] tracking-[0.22em] text-center py-1 px-1 leading-none">
        CONSTRUCTIONS
      </span>
    </span>
  );
};

export default Logo;
